module.exports = __webpack_public_path__ + "static/media/logo-footer.3d9c3dcf.svg";